import { VectorTileListServices } from './VectorTileListServices';
import { useVectorTileSettings } from '../../VectorTiles/useVectorTileSettings';
import { useLocalization } from '@ais-ui/locale-management';

export function VectorTileForm() {
  const { messages } = useLocalization();
  const vectorTiles = useVectorTileSettings();

  return (
    <div className="space-y-8">
      <VectorTileListServices />
    </div>
  );
}
